var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 51.5C98 25.8281 77.1719 5 51.5 5C25.8281 5 5 25.8281 5 51.5C5 77.1719 25.8281 98 51.5 98C77.1719 98 98 77.1719 98 51.5Z",
    stroke: "#FF4D4F",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0015 29.4538L51.5013 59L52.9985 29.4538C53.0077 29.2649 52.9753 29.0762 52.9033 28.8993C52.8312 28.7225 52.721 28.5611 52.5794 28.425C52.4379 28.2889 52.2678 28.1811 52.0798 28.108C51.8917 28.035 51.6895 27.9982 51.4856 28.0001C51.2842 28.0018 51.0851 28.0412 50.9004 28.1159C50.7157 28.1905 50.5491 28.2989 50.4106 28.4346C50.2721 28.5703 50.1645 28.7305 50.0942 28.9056C50.0239 29.0807 49.9924 29.2671 50.0015 29.4538Z",
    stroke: "#FF4D4F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 79C50.61 79 49.74 78.7068 48.9999 78.1573C48.2599 77.6079 47.6831 76.827 47.3425 75.9134C47.002 74.9998 46.9128 73.9945 47.0865 73.0245C47.2601 72.0546 47.6887 71.1637 48.318 70.4645C48.9474 69.7652 49.7492 69.289 50.6221 69.0961C51.495 68.9031 52.3998 69.0022 53.2221 69.3806C54.0443 69.759 54.7471 70.3999 55.2416 71.2221C55.7361 72.0444 56 73.0111 56 74C56 75.3261 55.5259 76.5978 54.682 77.5355C53.8381 78.4732 52.6935 79 51.5 79Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleOutline);
export default __webpack_public_path__ + "static/media/alertCircleOutline.1b6ccfee2e8cad5d118dbf65840125f3.svg";
export { ForwardRef as ReactComponent };